import { canv } from "@/canv/global.js";
import type { textWidget } from "@/elements/text/text";
import { Shape } from "@/shapeStorage/shapes/shape";

export class ShapePool extends Shape {
    width = 190;
    height = 80;
    defaultColor = "#000000";

    setDrawStyle(_: any): void {}

    fitText(
        textPart: textWidget,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 7) / 8 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + (width * 7) / 8 / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(
        x: number,
        y: number,
        w: number,
        h: number,
        shapeStyles: {
            color: string;
            borderColor: string;
            borderDashType: string;
            borderWidth: number;
        },
    ) {
        let r = h / 50;

        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;
        canv.ctx.save();
        canv.ctx.fillStyle = shapeStyles.color;
        canv.ctx.strokeStyle = shapeStyles.borderColor;
        canv.ctx.lineWidth = shapeStyles.borderWidth;

        canv.ctx.beginPath();
        this.setStrokeType(
            shapeStyles.borderColor,
            shapeStyles.borderDashType,
            shapeStyles.borderWidth,
        );

        canv.ctx.moveTo(x + r, y);
        canv.ctx.arcTo(x + w, y, x + w, y + h, r);
        canv.ctx.arcTo(x + w, y + h, x, y + h, r);
        canv.ctx.arcTo(x, y + h, x, y, r);
        canv.ctx.arcTo(x, y, x + w, y, r);
        canv.ctx.closePath();
        canv.ctx.globalAlpha = 0.1;
        canv.ctx.fill();
        canv.ctx.globalAlpha = 1;
        canv.ctx.stroke();
        canv.ctx.restore();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "#E8E8EE";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "#E8E8EE";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg fill="none" width="${width}" height="${height}" viewBox="0 0 23 10" xmlns="http://www.w3.org/2000/svg">
                <path d="m21.75 8.75v-7.999999l-21-.000001v8z"
                fill="${fill}" stroke="${stroke}" stroke-linejoin="round"/>
            </svg>
        `;
    }
}
